import {Prize, PrizeData} from "alpine";

export const allPrizes: Map<Prize, PrizeData> = new Map([]);

allPrizes.set('beer', {
    title: 'Čepovaný Budvar zdarma',
    description: '<p>Gratulujeme k výhře!<br><br>Za chvíli Vám přijde SMS s instrukcemi, jak&nbsp;získat čepovaný Budvar&nbsp;zdarma.</p>',
    claimedText: 'Vychutnejte si čepovaný Budvar zdarma',
    image: 'beer',
});

allPrizes.set('trip_italy', {
    title: 'Lyžařský zájezd do Itálie',
    description: '<p>Gratulujeme k výhře!<br>Brzy Vás budeme kontaktovat.</p>',
    claimedText: '',
    image: 'trip-italy',
});

allPrizes.set('bag', {
    title: 'Sportovní vak',
    description: '<p>Gratulujeme k výhře! Za chvíli Vám přijde SMS s&nbsp;instrukcemi.</p>',
    claimedText: 'Sportovní vak je váš',
    image: 'bag',
});

allPrizes.set('cap', {
    title: 'Raškovka',
    description: '<p>Gratulujeme k výhře! Za chvíli Vám přijde SMS s&nbsp;instrukcemi.</p>',
    claimedText: 'Raškovka je vaše',
    image: 'cap',
});

allPrizes.set('socks', {
    title: 'Ponožky',
    description: '<p>Gratulujeme k výhře! Za chvíli Vám přijde SMS s&nbsp;instrukcemi.</p>',
    claimedText: 'Ponožky jsou vaše',
    image: 'socks',
});

allPrizes.set('neck-warmer', {
    title: 'Nákrčník',
    description: '<p>Gratulujeme k výhře! Za chvíli Vám přijde SMS s&nbsp;instrukcemi.</p>',
    claimedText: 'Nákrčník je váš',
    image: 'neck-warmer',
});

allPrizes.set('keychain', {
    title: 'Klíčenka',
    description: '<p>Gratulujeme k výhře! Za chvíli Vám přijde SMS s&nbsp;instrukcemi.</p>',
    claimedText: 'Klíčenka je vaše',
    image: 'keychain',
});
